import AxiosClient from "../../../services/axios.services";

class WorkFlowBlockCheckListServices {
  getWorkFlowBlockCheckLists = (params, type) =>
    AxiosClient.get(
      type === 1
        ? "/api/app/On_off_bording_tarea_plantilla"
        : "/api/app/On_off_bording_tarea",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  getWorkFlowBlockCheckList = (id, type) =>
    AxiosClient.get(
      type === 1
        ? `/api/app/On_off_bording_tarea_plantilla/${id}`
        : `/api/app/On_off_bording_tarea/${id}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  saveWorkFlowBlockCheckLists = (data, type) =>
    AxiosClient.post(
      type === 1
        ? "/api/app/On_off_bording_tarea_plantilla/"
        : "/api/app/On_off_bording_tarea/",
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

  editWorkFlowBlockCheckLists = (id, data, type) =>
    AxiosClient.put(
      type === 1
        ? `/api/app/On_off_bording_tarea_plantilla/${id}/`
        : `/api/app/On_off_bording_tarea/${id}/`,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

  deleteWorkFlowBlockCheckLists = (id, type) =>
    AxiosClient.delete(
      type === 1
        ? `/api/app/On_off_bording_tarea_plantilla/${id}/`
        : `/api/app/On_off_bording_tarea/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  dateManage = (data) =>
    AxiosClient.post("/api/app/On_off_boarding_Control_Fechas/", data, {
      headers: { "Content-Type": "application/json" },
    });

  dateManageWorkFlow = (data) =>
    AxiosClient.post(
      "/api/app/On_off_boarding_workflow_Control_Fechas/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  saveWorkFlowBlockCheckListPosition = (data) =>
    AxiosClient.post("api/app/On_off_bording_posicion/", data, {
      headers: { "Content-Type": "application/json" },
    });

  estadoActividad = (data, type) =>
    AxiosClient.post(
      type
        ? `/api/app/admin_cierra_tareas/`
        : `/api/app/On_off_bording_estado/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  estadoActividadCierre = (data) =>
    AxiosClient.put(`/api/app/cierre_de_tareas/${data.tarea_id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new WorkFlowBlockCheckListServices();
